(function ($) {
    'use strict';

    const SELECTOR = {
        sourceLists: '.variant-list, .surcharge-list',
        sourceSelects: '.variant-list select, .surcharge-list select',
        variantSelects: '.variant-list select',
        customVariant: '.custom-variant-wrap .variant'
    };

    function normalizeAvailability(value) {
        return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().replace(/\s+/g, '-').toLowerCase();
    }

    // Shoptet k nedostupným variantám přidává do textu option status
    // (např. "180 g - Momentálně nedostupné"). Ten do labelu nechceme.
    const UNAVAILABLE_SUFFIX = /\s*[-–—]\s*(moment[aá]lně\s+)?(nedostupn[éeě]|vyprod[aá]no|na\s+dotaz)\s*$/i;

    function stripAvailabilitySuffix(text) {
       // return String(text || '').replace(UNAVAILABLE_SUFFIX, '').trim();
       return String(text || '').trim();
    }

    function getProductTitle() {
        return stripAvailabilitySuffix($.trim($('.p-detail-inner-header h1').first().text()));
    }

    function parseOptionText(text) {
        const optionText = stripAvailabilitySuffix(String(text || '').trim());
        const plusIndex = optionText.indexOf('+');

        if (plusIndex === -1) {
            return { name: optionText, surcharge: '' };
        }

        return { name: optionText.slice(0, plusIndex).trim(), surcharge: optionText.slice(plusIndex + 1).trim() };
    }

    function parsePriceNumber(priceText) {
        const match = String(priceText || '').match(/\d[\d\s.,]*/);

        if (!match) {
            return NaN;
        }

        let numberText = match[0].replace(/\s/g, '');

        numberText = numberText.indexOf(',') !== -1 && numberText.indexOf('.') !== -1
            ? numberText.replace(/\./g, '').replace(',', '.')
            : numberText.replace(',', '.');

        return parseFloat(numberText);
    }

    /*
     * Z labelu vytáhne hmotnost (např. "100 g" nebo "1,5 kg") a spočítá
     * cenu za 1 kg. Používá se pro doplnění span.unit-price u variant,
     * jejichž cena přišla ze shoptet.variantsSplit.necessaryVariantData.
     */
    function getPricePerKgText(labelText, priceText) {
        const weightMatch = String(labelText || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);

        if (!weightMatch) {
            return '';
        }

        const amount = parseFloat(weightMatch[1].replace(',', '.'));
        const weightKg = weightMatch[2].toLowerCase() === 'g' ? amount / 1000 : amount;
        const price = parsePriceNumber(priceText);

        if (!weightKg || weightKg <= 0 || !isFinite(price)) {
            return '';
        }

        const formatted = (price / weightKg).ShoptetFormatAsCurrency();

        return ` (${formatted} Kč / 1 kg)`;
    }

    // ---------------------------------------------------------------
    // Množství + rezervační tlačítko (bez <form>)
    //
    // Rezervace se neodesílá formulářem, ale voláním
    // shoptet.cartShared.addToCart({ productCode, amount }).
    // ---------------------------------------------------------------

    function getAmountBounds($input) {
        // data-effective-max-quantity je autoritativní limit, který počítá
        // _calendar.js jako min(skladový limit, denní limit z API). Je to
        // jediné místo, které tuto hodnotu zapisuje, takže na rozdíl
        // od "max" atributu ho nemůže přepsat nic jiného (Shoptet apod.).
        // Bez něj (např. u variant bez kalendáře) padáme zpět na "max".
        const effectiveMaxRaw = $input.attr('data-effective-max-quantity');
        const effectiveMax = parseInt(effectiveMaxRaw, 10);

        const max = effectiveMaxRaw !== undefined && !isNaN(effectiveMax)
            ? effectiveMax
            : (parseInt($input.attr('max'), 10) || 9999);

        return { min: parseInt($input.attr('min'), 10) || 1, max };
    }

    function clampVariantAmount(value, min, max) {
        let parsed = parseInt(value, 10);

        if (isNaN(parsed)) parsed = min;
        if (parsed < min) parsed = min;
        if (parsed > max) parsed = max;

        return parsed;
    }

    function buildQuantityControls({ min, max, decimals }) {
        const $quantity = $('<span>', { class: 'quantity' });

        $('<span>', {
            class: 'increase-tooltip js-increase-tooltip',
            'data-trigger': 'manual',
            'data-container': 'body',
            'data-original-title': `${hlaskamnozstvi} ${max} ks.${hlaskazamnozstvim}`,
            'aria-hidden': 'true',
            role: 'tooltip',
            'data-testid': 'tooltip',
            title: ''
        }).appendTo($quantity);

        $('<span>', {
            class: 'decrease-tooltip js-decrease-tooltip',
            'data-trigger': 'manual',
            'data-container': 'body',
            'data-original-title': `Minimální množství, které lze zakoupit, je ${min} ks.`,
            'aria-hidden': 'true',
            role: 'tooltip',
            'data-testid': 'tooltip'
        }).appendTo($quantity);

        const $label = $('<label>');

        // Pozor: 'autocomplete' se nesmí předat do $('<input>', {...}), protože jQuery UI
        // registruje metodu .autocomplete() a jQuery by ji zavolala místo nastavení atributu
        // ("cannot call methods on autocomplete prior to initialization"). Nastavíme přes .attr().
        $('<input>', { type: 'number', value: min, class: 'amount', 'data-decimals': decimals, step: 1, min, max, 'aria-label': 'Množství', 'data-testid': 'cartAmount' })
            .attr('autocomplete', 'off')
            .appendTo($label);

        $label.appendTo($quantity);

        $('<button>', { class: 'increase', type: 'button', 'aria-label': `Zvýšit množství o 1, maximálně ${max} ks`, 'data-testid': 'increase' })
            .append($('<span>', { class: 'increase__sign', text: '+' }))
            .appendTo($quantity);

        $('<button>', { class: 'decrease', type: 'button', 'aria-label': 'Snížit množství o 1', 'data-testid': 'decrease' })
            .append($('<span>', { class: 'decrease__sign', text: '−' }))
            .appendTo($quantity);

        return $quantity;
    }

    function buildReserveButton() {
        return $('<button>', { type: 'button', class: 'btn btn-cart add-to-cart-button', 'aria-disabled': 'false' }).append($('<span>', { text: 'Rezervovat' }));
    }

    function updateVariantQuantityTooltip($variant) {
        const $amount = $variant.find('.quantity input.amount').first();

        if (!$amount.length) {
            return;
        }

        const bounds = getAmountBounds($amount);
        const $increaseTooltip = $variant.find('.increase-tooltip').first();
        const $decreaseTooltip = $variant.find('.decrease-tooltip').first();

        if ($increaseTooltip.length) {
            const msg = `${hlaskamnozstvi} ${bounds.max} ks.${hlaskazamnozstvim}`;
            $increaseTooltip.attr('data-original-title', msg).attr('title', msg).removeData('original-title').data('original-title', msg);
        }

        if ($decreaseTooltip.length) {
            const msg = `Minimální množství, které lze zakoupit, je ${bounds.min} ks.`;
            $decreaseTooltip.attr('data-original-title', msg).removeData('original-title').data('original-title', msg);
        }

        $variant.find('.quantity .increase').first().attr('aria-label', `Zvýšit množství o 1, maximálně ${bounds.max} ks`);
    }

    function reserveVariant($variant) {
        if ($variant.hasClass('unavailable') || $variant.attr('aria-busy') === 'true') {
            return;
        }

        const productCode = $variant.attr('data-product-code');

        if (!productCode) {
            return;
        }

        const $amount = $variant.find('.quantity input.amount').first();
        const bounds = getAmountBounds($amount);
        const amount = clampVariantAmount($amount.val(), bounds.min, bounds.max);

        $amount.val(amount);

        if (window.shoptet && window.shoptet.cartShared && typeof window.shoptet.cartShared.addToCart === 'function') {
            window.shoptet.cartShared.addToCart({ productCode, amount });
        }
    }

    function showQuantityLimitMessage($variant, message) {
        $variant.next('.quantity-limit-message')
            .text(message)
            .show();
    }

    function hideQuantityLimitMessage($variant) {
        $variant.next('.quantity-limit-message')
            .text('')
            .hide();
    }

    function createVariantElement({ value, parameterId, text, tooltip, isVariant }) {
        let $message = null;
        const $variant = $('<div>', {
            class: isVariant ? 'variant haveVariant' : 'variant haveSurcharge show-tooltip',
            'data-value': value,
            'data-parameter-id': parameterId,
            'data-param-val': `${parameterId}-${value}`
        });

        if (isVariant) {
            const parsedText = parseOptionText(text);
            const baseLabel = parsedText.surcharge ? `${parsedText.name} (+${parsedText.surcharge})` : parsedText.name;
            const title = baseLabel//getProductTitle();

            // Když už baseLabel obsahuje název produktu (Shoptet ho někdy dává do option),
            // nezdvojujeme ho. Jinak spojíme "název, label". Availability se strhává vždy.
            let label = baseLabel;
          //  label = stripAvailabilitySuffix(label);
         
            const $text = $('<div>', { class: 'text' });

            $('<span class="label">'+label+'</span>').appendTo($text);

            if (tooltip && parsedText.surcharge && parsedText.surcharge !== '0 Kč') {
                $('<span>', { class: 'show-tooltip question-tooltip', title: tooltip, text: '?' }).appendTo($text);
            }

            $variant.append($text);

            // Množství + rezervace v obalovém divu (metadata min/max/decimals doplní applyVariantMetadata).
            const $cart = $('<div>', { class: 'customCart' });

            $cart.append(buildQuantityControls({
    min: 1,
    max: 9999,
    decimals: 0
}));

$cart.append(buildReserveButton());

$variant.append($cart);

$message = $('<div>', {
    class: 'quantity-limit-message',
    role: 'alert',
    'aria-live': 'polite'
}).hide();
        } else {
            $variant.attr('title', text);

            const imageUrl = `/user/documents/upload/obrazky/detail/priplatky/${encodeURIComponent(value)}.svg`;
            const $image = $('<div>', { class: 'image' });

            $('<img>', { src: imageUrl, alt: text }).appendTo($image);
            $variant.append($image);
        }

        return $message ? $($.merge($variant.toArray(), $message.toArray())) : $variant;
    }

    // Skryje původní Shoptet prvky, které vlastní varianty nahrazují.
    function hideNativeControls() {
        $('.p-final-price-wrapper, .availability-value, .add-to-cart').hide();
    }

    function createCustomVariants() {
        if ($('#simple-variants').length) {
            return;
        }

        if (!$(SELECTOR.sourceLists).length) {
            return;
        }

        hideNativeControls();

        $(SELECTOR.sourceSelects).each(function () {
            const $select = $(this);
            const $list = $select.closest('.variant-list, .surcharge-list');

            // Zabrání opakovanému vytvoření variant, pokud se skript spustí vícekrát.
            if ($select.next('.custom-variant').length) {
                return;
            }

            const parameterId = String($select.attr('data-parameter-id') || '');
            const parameterName = $select.attr('data-parameter-name') || '';
            const isVariantSelect = $select.closest('td').find('select[name*="parameterValueId"]').length > 0;
            const tooltip = $select.closest('.surcharge-list').find('th .show-tooltip').first().attr('title') || '';

            const $customVariant = $('<div>', { class: 'custom-variant', 'data-group-id': parameterId });

            $('<div>', { class: 'h3', text: 'Vyberte variantu:' }).appendTo($customVariant);

            const $wrapper = $('<div>', { class: 'custom-variant-wrap', 'data-param-id': parameterId });

            $select.find('option').each(function () {
                const $option = $(this);
                const value = String($option.val() || '');

                // Přeskočí úvodní možnost: "Zvolte variantu".
                if (!$.isNumeric(value)) {
                    return;
                }

                createVariantElement({ value, parameterId, text: $option.text(), tooltip, isVariant: isVariantSelect }).appendTo($wrapper);
            });

            $customVariant.append($wrapper);
            $select.after($customVariant).hide();

            // Pozor: skrývá pouze přímé span potomky řádku. Nebude skrývat tooltipy uvnitř vlastní varianty.
            $list.children('span').hide();
            $list.addClass('haveVariant');
        });
    }

    function getSelectByParameterId(parameterId) {
        return $(`select[data-parameter-id="${parameterId}"]`).first();
    }

    function getOptionByValue($select, value) {
        return $select.find('option').filter(function () { return String(this.value) === String(value); }).first();
    }

    function isOptionUnavailable($option) {
        if (!$option.length) {
            return true;
        }

        return $option.hasClass('unavailable-option') || $option.closest('optgroup').hasClass('unavailable-variants') || $option.prop('disabled');
    }

function syncCustomVariants() {
    $(SELECTOR.customVariant).each(function () {
        const $variant = $(this);
        const parameterId = String($variant.attr('data-parameter-id'));
        const value = String($variant.attr('data-value'));
        const $select = getSelectByParameterId(parameterId);
        const $option = getOptionByValue($select, value);
        const unavailable = isOptionUnavailable($option);

        if ($option.length) {
            const cleanLabel = stripAvailabilitySuffix($option.text());

            $variant.find('.label').first()
                .attr('data-original-label', cleanLabel)
                .text(cleanLabel);
        }

        $variant.toggleClass('unavailable', unavailable);

        if (unavailable) {
            $variant.removeClass('active');
        }
    });

    syncActiveVariants();
}

    function syncActiveVariants() {
        $(SELECTOR.variantSelects).each(function () {
            const $select = $(this);
            const parameterId = String($select.attr('data-parameter-id'));
            const selectedValue = String($select.val() || '');
            const $wrapper = $(`.custom-variant-wrap[data-param-id="${parameterId}"]`);

            if (!$wrapper.length) {
                return;
            }

            $wrapper.find('.variant').removeClass('active');

            if (!selectedValue) {
                return;
            }

            const $selectedVariant = $wrapper.find('.variant').filter(function () { return String($(this).attr('data-value')) === selectedValue; }).first();

            if ($selectedVariant.length && !$selectedVariant.hasClass('unavailable')) {
                $selectedVariant.addClass('active');
            }
        });
    }

    function scheduleVariantSync() {
        // Shoptet může měnit selecty až po dokončení aktuální change události.
        window.requestAnimationFrame(function () {
            syncCustomVariants();
            // Druhý frame pokryje opožděný přesun option do optgroup unavailable-variants.
            window.requestAnimationFrame(syncCustomVariants);
        });
    }

    /*
     * Doplní do .text spany price/unit-price podle dat z necessaryVariantData.
     * Label necháváme tak, jak byl vytvořen z textu <option> (viz
     * createVariantElement) - jen k němu podle potřeby přidáme/aktualizujeme
     * cenu a přepočet na kg.
     */
function applyVariantPriceText($variant, variant) {
    const $text = $variant.children('.text').first();

    if (!$text.length) {
        return;
    }

    let $price = $text.find('.price').first();

    if (variant.price) {
        if (!$price.length) {
            $price = $('<span>', {
                class: 'price'
            }).appendTo($text);
        }

        $price.text(variant.price);
    } else if ($price.length) {
        $price.remove();
    }

    const paramValue = String($variant.attr('data-param-val') || '');
    let $unitPriceSource = $();

    // Varianta s třídou např. "23-128"
    if (paramValue) {
        $unitPriceSource = $('.p-final-price-wrapper .price-measure span')
            .filter(function () {
                return $(this).hasClass(paramValue);
            })
            .first();
    }

    // Produkt bez variantní měrné ceny
    if (!$unitPriceSource.length) {
        $unitPriceSource = $('.p-final-price-wrapper .price-measure > span')
            .not('.sr-only')
            .filter(function () {
                return $.trim($(this).text()) !== '';
            })
            .first();
    }

    let unitPriceText = '';

    if ($unitPriceSource.length) {
        unitPriceText = $.trim($unitPriceSource.text())
            .replace(/\s+/g, ' ')
            .replace(/^od\s+/i, '');
    }

    let $unitPrice = $text.find('.unit-price').first();

    if (unitPriceText) {
        if (!$unitPrice.length) {
            $unitPrice = $('<span>', {
                class: 'unit-price'
            }).appendTo($text);
        }

        $unitPrice.text(' (' + unitPriceText + ')');
    } else if ($unitPrice.length) {
        $unitPrice.remove();
    }
}

    function applyVariantMetadata() {
        const necessaryVariantData = window.shoptet && window.shoptet.variantsSplit && window.shoptet.variantsSplit.necessaryVariantData;

        if (!necessaryVariantData) {
            return;
        }

        Object.entries(necessaryVariantData).forEach(function ([combinationKey, variant]) {
            /*
             * Klíče mají například tvar: 4-55-5-37
             * Neodpovídají tedy přímo data-param-val, které má tvar pouze
             * 4-55. Metadata konkrétní kombinace proto dáváme variantám
             * podle obsažených dvojic parametr-hodnota.
             */
            const combinationParts = combinationKey.split('-');

            for (let index = 0; index < combinationParts.length; index += 2) {
                const parameterId = combinationParts[index];
                const value = combinationParts[index + 1];

                if (typeof parameterId === 'undefined' || typeof value === 'undefined') {
                    continue;
                }

                const paramValue = `${parameterId}-${value}`;
                const $variant = $(`.custom-variant-wrap .variant[data-param-val="${paramValue}"]`);

                if (!$variant.length) {
                    continue;
                }

                $variant.addClass('haveImage').attr({
                    'data-price-id': variant.id,
                    'data-product-code': variant.code,
                    'data-avail': normalizeAvailability(variant.availabilityName)
                });

                applyVariantPriceText($variant, variant);

                // Množstevní meze z necessaryVariantData na input/tooltipy.
                const min = parseInt(variant.minimumAmount, 10) || 1;
                const max = parseInt(variant.maximumAmount, 10) || 9999;
                const decimals = parseInt(variant.decimalCount, 10) || 0;

                $variant.find('.quantity input.amount').attr({ min, max, 'data-decimals': decimals }).each(function () {
                    $(this).val(clampVariantAmount($(this).val(), min, max));
                });

                updateVariantQuantityTooltip($variant);
            }
        });
    }

    function initializeActiveVariants() {
        $('.custom-variant-wrap').each(function () {
            const $wrapper = $(this);
            const $variants = $wrapper.find('.variant');
            const $availableVariants = $variants.not('.unavailable');

            if ($variants.length === 1 && $availableVariants.length === 1) {
                $availableVariants.addClass('active');

                const parameterId = String($wrapper.attr('data-param-id'));
                const value = String($availableVariants.attr('data-value'));
                const $select = getSelectByParameterId(parameterId);

                if (!$select.val()) {
                    $select.val(value).trigger('change');
                }
            }
        });

        // Původní parameterValueId v URL. U více parametrů může URL obsahovat hodnotu pouze jednoho parametru.
        const parameterValueId = new URLSearchParams(window.location.search).get('parameterValueId');

        if (parameterValueId) {
            const $variant = $(`.custom-variant-wrap .variant[data-value="${parameterValueId}"]`).not('.unavailable').first();

            if ($variant.length) {
                const $wrapper = $variant.closest('.custom-variant-wrap');
                $wrapper.find('.variant').removeClass('active');
                $variant.addClass('active');
            }
        }

        syncActiveVariants();
    }

    function observeVariantSelects() {
        if (typeof MutationObserver === 'undefined') {
            return;
        }

        const observer = new MutationObserver(function () { scheduleVariantSync(); });

        $(SELECTOR.variantSelects).each(function () {
            observer.observe(this, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled', 'selected'] });
        });
    }

    $(document).on('click', SELECTOR.customVariant, function (event) {
        // Klik do množství / rezervačního tlačítka řeší specializované handlery níže.
        if ($(event.target).closest('.quantity, .add-to-cart-button').length) {
            return;
        }

        event.preventDefault();

        const $variant = $(this);

        if ($variant.hasClass('unavailable')) {
            return;
        }

        const value = String($variant.attr('data-value'));
        const parameterId = String($variant.attr('data-parameter-id'));
        const $wrapper = $variant.closest('.custom-variant-wrap');
        const $select = getSelectByParameterId(parameterId);

        if (!$select.length) {
            return;
        }

        const $option = getOptionByValue($select, value);

        if (isOptionUnavailable($option)) {
            $variant.addClass('unavailable');
            return;
        }

        // Aktivní stav se mění pouze uvnitř aktuální skupiny, například pouze velikosti.
        $wrapper.find('.variant').removeClass('active');
        $variant.addClass('active');

        // Hodnota se nastaví přímo na select. Change následně nechá Shoptet přepočítat dostupnost ostatních parametrů.
        $select.val(value).trigger('change');

        scheduleVariantSync();
    });

    $(document)
    .off(
        'click.customVariantQuantity',
        '.custom-variant-wrap .quantity .increase'
    )
    .on(
        'click.customVariantQuantity',
        '.custom-variant-wrap .quantity .increase',
        function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            const $variant = $(this).closest('.variant');
            const $amount = $variant.find('.quantity input.amount').first();
            const bounds = getAmountBounds($amount);

            let currentAmount = parseInt($amount.val(), 10);

            if (Number.isNaN(currentAmount)) {
                currentAmount = bounds.min;
            }

            if (currentAmount >= bounds.max) {
                $amount.val(bounds.max);

                showQuantityLimitMessage(
                    $variant,
                    `${hlaskamnozstvi} ${bounds.max} ks.${hlaskazamnozstvim}`
                );

                return;
            }

            const newAmount = currentAmount + 1;

            $amount.val(newAmount);

            if (newAmount >= bounds.max) {
                hideQuantityLimitMessage($variant);
            } else {
                hideQuantityLimitMessage($variant);
            }

            updateVariantQuantityTooltip($variant);
        }
    );


$(document)
    .off(
        'click.customVariantQuantity',
        '.custom-variant-wrap .quantity .decrease'
    )
    .on(
        'click.customVariantQuantity',
        '.custom-variant-wrap .quantity .decrease',
        function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            const $variant = $(this).closest('.variant');
            const $amount = $variant.find('.quantity input.amount').first();
            const bounds = getAmountBounds($amount);

            let currentAmount = parseInt($amount.val(), 10);

            if (Number.isNaN(currentAmount)) {
                currentAmount = bounds.min;
            }

            const newAmount = clampVariantAmount(
                currentAmount - 1,
                bounds.min,
                bounds.max
            );

            $amount.val(newAmount);

            hideQuantityLimitMessage($variant);
            updateVariantQuantityTooltip($variant);
        }
    );


   $(document)
    .off(
        'input.customVariantQuantity change.customVariantQuantity',
        '.custom-variant-wrap .quantity input.amount'
    )
    .on(
        'input.customVariantQuantity change.customVariantQuantity',
        '.custom-variant-wrap .quantity input.amount',
        function (event) {
            event.stopPropagation();

            const $amount = $(this);
            const $variant = $amount.closest('.variant');
            const bounds = getAmountBounds($amount);

            let enteredAmount = parseInt($amount.val(), 10);

            if (Number.isNaN(enteredAmount)) {
                return;
            }

            if (enteredAmount > bounds.max) {
                $amount.val(bounds.max);

                showQuantityLimitMessage(
                    $variant,
                    `${hlaskamnozstvi} ${bounds.max} ks.${hlaskazamnozstvim}`
                    //`Není možné zakoupit více než ${bounds.max} ks.`
                );
            } else {
                $amount.val(
                    clampVariantAmount(
                        enteredAmount,
                        bounds.min,
                        bounds.max
                    )
                );

                hideQuantityLimitMessage($variant);
            }

            updateVariantQuantityTooltip($variant);
        }
    );

    $(document).on('click', '.custom-variant-wrap .add-to-cart-button', function (event) {
        event.preventDefault();
        event.stopPropagation();
        reserveVariant($(this).closest('.variant'));
    });

    // Zachytí změny selectů provedené Shoptetem nebo jiným skriptem.
    $(document).on('change', SELECTOR.variantSelects, function () { scheduleVariantSync(); });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function () {
        window.requestAnimationFrame(function () {
            syncCustomVariants();
            syncActiveVariants();
        });
    });

    $(function () {
        createCustomVariants();
        applyVariantMetadata();
        syncCustomVariants();
        initializeActiveVariants();
        observeVariantSelects();

        // Ještě jedna synchronizace po inicializaci, protože Shoptet může dostupnost nastavit později.
        scheduleVariantSync();
    });
})(jQuery);